import { render, staticRenderFns } from "./PoundageSet.vue?vue&type=template&id=45d2583f&scoped=true&"
import script from "./PoundageSet.vue?vue&type=script&lang=js&"
export * from "./PoundageSet.vue?vue&type=script&lang=js&"
import style0 from "./PoundageSet.vue?vue&type=style&index=0&id=45d2583f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d2583f",
  null
  
)

export default component.exports